import { ConfigConstants } from "common/utils/shared/shared-constants";
import config from 'config';

export type MinimalTinyMCEEditor = {
    focus: () => void;
    insertContent: (content: string) => void;
    selection: {
      setContent: (content: string) => void;
      getBookmark: (type: number, normalized: boolean) => any;
      moveToBookmark: (bookmark: any) => void;
      collapse: (toStart?: boolean) => void;
    };
  };

  export const getTinyMceApiKey  = (): string => {
    return config.get(ConfigConstants.TinyMceApiKey) || '';
  }

 export const tinyMceEditorInit = {
    height: 150,
    convert_urls: true,
    plugins: 'lists',
    toolbar: `bullist numlist | bold italic underline | alignleft aligncenter alignright alignjustify`,
    menubar: false,
    branding: false,
    force_br_newlines: true,
    force_p_newlines: false,
    forced_root_block: false,
} as const;